import Vue from 'vue'
import _ from 'lodash'

import * as query from '@/queries/product'
import common from '@/utils/common'
import moment from 'moment'
import message from '@/utils/message'

export const defaultState = function () {
  return {
    isAndSearch: false,
    searchKeyword: '',
    searchKey: 'product_list',
    searchConditions: {}
  }
}

export default {
  namespaced: true,
  state: defaultState(),
  getters: {
    productDetail: (state) => {
      return state.productDetail || {}
    },
    productDatetime: (state) => {
      return state.productDatetime
    }
  },
  actions: {
    async fetchProductDetail ({ commit }, { uuid, productDatetime }) {
      try {
        let param = common.addGraphQlCondition(
          query.GRAPH_QL_QUERY_PRODUCT_DETAIL,
          { uuid })
        param = common.addGraphQlCondition(
          param, { uuid, baseDateTime: productDatetime })
        const res = await common.postGraphQl(param)
        // fku/skuからカラー/サイズバリエーションを作成する。
        const colorVariations = []
        const sizeVariations = []
        const product = _.get(res, 'data.data.product', null)
        if (product == null) {
          // 結果が null の場合
          this.$notify.error({
            message: message.MSG_301()
          })
          return
        }
        const fkus = product.fkus
        fkus.forEach((fku) => {
          const addColorCode = _.get(fku, 'color.code')
          if (addColorCode) {
            colorVariations.push(addColorCode.toString())
          }
          const skus = _.get(fku, 'skus')
          skus.forEach((sku) => {
            const addSizeCode = _.get(sku, 'size.code')
            if (addSizeCode && !sizeVariations.includes(addSizeCode)) {
              sizeVariations.push(addSizeCode.toString())
            }
          })
        })

        if (colorVariations) {
          _.set(res, 'data.data.product.colorVariations', colorVariations)
        }

        if (sizeVariations) {
          _.set(res, 'data.data.product.sizeVariations', sizeVariations)
        }

        const isJSONChange = (sJSON) => {
          try {
            const data = JSON.parse(sJSON)
            return Array.isArray(data)
          } catch (e) {
            return false
          }
        }

        // Attributeの値はString型になってしまうため、Int型のとき数値に置き換える
        let attributes = _.get(res, 'data.data.product.attributes', [])
        attributes.forEach((attribute) => {
          if (attribute.attrValue !== '' &&
            !Number.isNaN(attribute.attrValue) &&
            Number.isInteger(Number(attribute.attrValue))) {
            attribute.attrValue = Number(attribute.attrValue)
          } else if (isJSONChange(attribute.attrValue)) {
            // JSONの中身が配列時はオブジェクト化する
          } else {
            const date = moment(attribute.attrValue)
            if (date.isValid()) {
              // タイムゾーンがないUTCなので、タイムゾーン付きに変換する。
              attribute.attrValue = Vue.moment.tz(attribute.attrValue, this.timezone).format()
            }
          }
        })

        attributes = _.get(res, 'data.data.product.images.attributes', [])
        attributes.forEach((attribute) => {
          if (attribute.attrValue !== '' &&
          !Number.isNaN(attribute.attrValue) &&
            Number.isInteger(Number(attribute.attrValue))) {
            attribute.attrValue = Number(attribute.attrValue)
          } else if (isJSONChange(attribute.attrValue)) {
            // JSONの中身が配列時はオブジェクト化する
          } else {
            const date = moment(attribute.attrValue)
            if (date.isValid()) {
              // タイムゾーンがないUTCなので、タイムゾーン付きに変換する。
              attribute.attrValue = Vue.moment.tz(attribute.attrValue, this.timezone).format()
            }
          }
        })

        fkus.forEach((fku) => {
          const skus = _.get(fku, 'skus')
          skus.forEach((sku) => {
            sku.attributes.forEach((attribute) => {
              if (attribute.attrValue !== '' &&
                !Number.isNaN(attribute.attrValue) &&
                Number.isInteger(Number(attribute.attrValue))) {
                attribute.attrValue = Number(attribute.attrValue)
              } else if (isJSONChange(attribute.attrValue)) {
                // JSONの中身が配列時はオブジェクト化する
              } else {
                const date = moment(attribute.attrValue)
                if (date.isValid()) {
                  // タイムゾーンがないUTCなので、タイムゾーン付きに変換する。
                  attribute.attrValue = Vue.moment.tz(attribute.attrValue, this.timezone).format()
                }
              }
            })
          })
        })

        commit('setProductDetail', _.get(res, 'data.data.product'))
      } catch (error) {
        commit('setProductDetail', null)
        throw error
      }
    },
    async fetchProductDatetime ({ commit }, { uuid }) {
      try {
        const param = common.addGraphQlCondition(
          query.GRAPH_QL_QUERY_PRODUCT_DATETIME,
          { uuid })
        const res = await common.postGraphQl(param)
        commit('setProductDatetime', _.get(res, 'data.data.product.updatedAt'))
      } catch (error) {
        commit('setProductDatetime', null)
        throw error
      }
    },
    async setProductDetail ({ commit }, payload) {
      commit('setProductDetail', payload)
    }
  },
  mutations: {
    setProductDetail (state, payload) {
      Vue.set(state, 'productDetail', payload)
    },
    setProductDatetime (state, payload) {
      Vue.set(state, 'productDatetime', payload)
    }
  },
  getDefaultState: defaultState
}



// WEBPACK FOOTER //
// ./src/store/pages/productDetail.js